import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';

@Component({
    selector: 'lib-detail-view-layout',
    templateUrl: './detail-view-layout.component.html',
    styleUrls: ['./detail-view-layout.component.scss']
})
export class DetailViewLayoutComponent extends BaseViewComponent implements OnInit {
    @Input() hasBackButton: boolean = true;
    @Output() backClicked: EventEmitter<void> = new EventEmitter();

    BackButtonClicked(): void {
        this.backClicked.emit();
    }
}
